let db = null

function clearObject(tables) {
	Object.entries(tables).forEach(([key, table]) => {
		const tx = db.transaction(table, 'readwrite')
		tx.onerror = (e) => console.log(` Error! ${e.target.error}  `)
		const objectStore = tx.objectStore(table)
		const objectStoreRequest = objectStore.clear()
		objectStoreRequest.onsuccess = () => {
			console.log('clearObject successful')
		}
	})
}

function viewObject(table, filter, indexKey) {
	let temp = {}
	const tx = db.transaction(table, 'readonly')
	const objectStore = tx.objectStore(table)
	const index = objectStore.index(indexKey)
	const request = index.get(filter)
	request.onsuccess = (e) => {
		console.log(e.target.result)
		if (e.target.result !== undefined) {
			temp = e.target.result
			console.log(temp)
			return temp
		} else {
			console.log('No match was found.')
		}
	}
}

function viewObjects(table, filter, indexKey) {
	return new Promise(
    function(resolve, reject) {
			let arr = []
			let temp = {}
			let request = undefined
			const tx = db.transaction(table, 'readonly')
			const objectStore = tx.objectStore(table)
			if (filter === null) {
				request = objectStore.openCursor()
			} else {
				const index = objectStore.index(indexKey)
				request = index.openCursor(IDBKeyRange.only(filter))
			}
			request.onsuccess = (e) => {
				const cursor = e.target.result
				if (cursor) {
					Object.entries(cursor.value).forEach(([key, value]) => {
						temp[key] = value
					})
					arr.push(temp)
					temp = {}
					cursor.continue()
				}
				resolve(arr)
			}
			request.onerror = (e) => {
				reject(Error('Error on get data'))
			}
		}
	)
}

function addObject(table, data) {
	const tx = db.transaction(table, 'readwrite')
	tx.onerror = (e) => console.log(` Error! ${e.target.error}  `)
	const objectStore = tx.objectStore(table)
	objectStore.add(data)
}

function createDB() {
	const request = indexedDB.open('cetaba', 1)
	//on upgrade needed
	request.onupgradeneeded = (e) => {
		db = e.target.result
		db.createObjectStore('user', { keyPath: 'id' })

		console.log(
			`upgrade is called database name: ${db.name} version : ${db.version}`
		)
	}
	//on success
	request.onsuccess = (e) => {
		db = e.target.result
		console.log(
			`success is called database name: ${db.name} version : ${db.version}`
		)
	}
	//on error
	request.onerror = (e) => {
		console.log(`error: ${e.target.error} was found `)
	}
}
export default {
	clearObject,
	viewObject,
	viewObjects,
	addObject,
	createDB,
}
